import { render } from "./rentability-card.vue?vue&type=template&id=5fc5c2f3"
import script from "./rentability-card.vue?vue&type=script&lang=js"
export * from "./rentability-card.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__